import React from "react";

const AppLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-white via-violet-50 to-purple-50">
      <div className="flex flex-col items-center gap-8">

        {/* Brand Mark */}
        <div className="relative">
       
          {/* Soft glow */}
          <div className="absolute inset-0 rounded-2xl bg-violet-400/40 blur-2xl -z-10 animate-pulse" />
        </div>

        {/* Brand Text */}
        <div className="text-center space-y-1">
          <p className="text-2xl font-semibold tracking-wide bg-gradient-to-r from-violet-600 via-purple-500 to-violet-600 bg-clip-text text-transparent animate-shimmer">
            🫟
          </p>
          <p className="text-sm text-gray-500 tracking-wide">
            Your conversations, flowing…
          </p>
        </div>

        {/* Premium Progress Bar */}
        <div className="relative w-56 h-[6px] rounded-full bg-gray-200/70 overflow-hidden">
          <div className="absolute inset-0 animate-loader">
            <div className="w-1/3 h-full rounded-full bg-gradient-to-r from-violet-600 via-purple-500 to-violet-600 shadow-md" />
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes loader {
          0% {
            transform: translateX(-120%);
          }
          50% {
            transform: translateX(150%);
          }
          100% {
            transform: translateX(320%);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-6px);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: 0%;
          }
          100% {
            background-position: 200%;
          }
        }

        .animate-loader {
          animation: loader 1.6s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }

        .animate-shimmer {
          background-size: 200% auto;
          animation: shimmer 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default AppLoader;
